export default "__VITE_ASSET__CvL7lA$V__"